module.exports = __webpack_public_path__ + "img/Question.de6a1d92.svg";